/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { NumericFormat } from 'react-number-format';
import { StylesSurgirTextField } from 'utils/StylesSurgirTextField';

interface SurgirTextFieldProps {
  validateError: (value: string, dependValue?: any) => { error: boolean; message?: any };
  visibleError?: boolean;
  value: string;
  onClick?:any
  dependValue?: any;
  setValue: (value: string) => void;
  label: string;
  fullWidth?: boolean;
  variant: any;
  type?: string;
  disabled?: boolean;
  FormatCustom?: any;
  pattern?: any;
  prefix?: string;
}



const SurgirTextField: React.FC<SurgirTextFieldProps> = ({
  validateError,
  visibleError,
  value,
  dependValue,
  setValue,
  label,
  fullWidth,
  variant,
  type,
  disabled,
  FormatCustom = false,
  pattern,
  prefix,
}) => {
  const [error, setError] = useState(false);
  const [messageError, setMessageError] = useState(false);
  
  useEffect(() => {
    if (visibleError) {
      handleError(value);
    }
  }, [visibleError]);
  useEffect(() => {
    if (dependValue != undefined) {
      setError(false);
    }
  }, [dependValue]);

  const handleError = (valueTarget: any) => {
    if (
      dependValue != undefined &&
      dependValue != null &&
      dependValue != ""
    ) {
      setError(validateError(valueTarget, dependValue.value).error);
      setMessageError(validateError(valueTarget, dependValue.value).message);
    } else {
      setError(validateError(valueTarget).error);
      setMessageError(validateError(valueTarget).message);
    }
  };
  const handlChange = ({ target }: any) => {
    
    if (value!==null && target.value.length >= value.length) {
      if (pattern != undefined) {
        const data = target.value;
        const datasubString = data[data.length - 1];
        const cond1 = pattern.test(data);

        pattern.lastIndex = 0;
        const cond2 = pattern.test(datasubString);
        pattern.lastIndex = 0;
        if (cond1 && cond2) {
          setValue(target.value);
          setError(false);
        }
      } else {
        setValue(target.value);
        setError(false);
      }
    } else {
      setValue(target.value);
      setError(false);
    }
  };


  const NumericFormatCustomInput = (props: any) => (
    <StylesSurgirTextField
      {...props}
      onChange={(e: any) => {
        if (props.onChange) {
          props.onChange(e);
        }
      }}
      inputProps={{ maxLength: props.prefix === 'S/' ? 12 : 11, autoComplete: 'off' }}
      fullWidth={fullWidth}
      variant={variant}
      label={label}
    />
  );

  return (
    <>
      {
        !FormatCustom ? (
          <StylesSurgirTextField
            autoComplete="off"
            helperText={error ? messageError : ""}
            error={error}
            value={value}
            onChange={(e) => handlChange(e)}
            onClick={(e: any) => {
              if (disabled) {
                handleError(e.target.value);
              }
            }}
            label={label}
            fullWidth={fullWidth}
            variant={variant}
            inputProps={{ maxLength: 100, autoComplete: 'off'}} 
            type={type}
            disabled={disabled}
            onBlur={(e) => {
              handleError(value);
            }}
          />
        ) : (
          <NumericFormat
            thousandSeparator
            onBlur={e => setValue(e.target.value)}
            customInput={NumericFormatCustomInput}
            valueIsNumericString
            disabled={disabled}
            prefix={prefix}
            value={value}
            maxLength={9}
          />
        )

        
      }
    </>
  );
};

export { SurgirTextField };
